import { Button, EmptyState, Flex } from '@raystack/apsara';

import { ReactComponent as PixxelLogo } from '@src/icons/Logo-monogram.svg';

import styles from './styles.module.css';

export const AppBreakPointScreen = () => (
  <Flex align='center' className={styles.wrapper}>
    <EmptyState
      classNames={{ container: styles.emptyStateWrapper }}
      heading='Aurora works best on larger screens'
      subHeading="Our platform isn't optimized for screens under 768px. Switch to a larger device for the best experience."
      icon={<PixxelLogo />}
      secondaryAction={
        <Button
          variant='outline'
          color='neutral'
          data-test-id='read-more-btn-breakpoint'
          onClick={() =>
            window.open('https://www.pixxel.space/aurora', '_blank')
          }
        >
          Read more
        </Button>
      }
    />
  </Flex>
);
